// src/components/AddCartButton.js
// 1. Creates item object to add to the cart
// 2. Retrieves existing cart items from localStorage, checks if exists then updates quantity or adds a new item
// 3. Provides User Feedback: It updates the addedToCart state to show a confirmation message when an item is added to the cart.

import React, { useState } from 'react';

const AddCartButton = ({ item, onAddToCart }) => {
  const [addedToCart, setAddedToCart] = useState(false);

  const addToCartHandler = () => {
    if (onAddToCart) {
      onAddToCart(item);
      setAddedToCart(true);
      setTimeout(() => {
        setAddedToCart(false);
      }, 2000);
    }
  };

  return (
    <div>
      <button onClick={addToCartHandler}>Add to Cart</button>
      {addedToCart && <p style={{ color: 'green', marginTop: '5px' }}>Added to Cart!</p>}
    </div>
  );
};

export default AddCartButton;
